"use client";


import { useEffect } from "react";
import {
  captureAffiliateParams,
  configureAffiliateTracker,
} from "./affiliate-tracker";
import type { AffiliateConfig } from "./types";

interface AffiliateTrackerProps {
  config?: Partial<AffiliateConfig>;
  autoCapture?: boolean;
  children?: React.ReactNode;
}

const AffiliateTracker: React.FC<AffiliateTrackerProps> = ({
  config,
  autoCapture = true,
  children,
}) => {
  useEffect(() => {
    // Configure the tracker if config is provided
    if (config) {
      configureAffiliateTracker(config);
    }

    // Auto-capture affiliate params if enabled
    if (autoCapture) {
      captureAffiliateParams();
    }
  }, [config, autoCapture]);

  return children ? <>{children}</> : null;
};

export default AffiliateTracker;
export type { AffiliateTrackerProps };
